(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rivt-purchase-confidence"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rivt-dispatch-date')) {
    customElements.define('rivt-dispatch-date', class extends HTMLElement {
      connectedCallback() {
        this.updateDate();
        this.timer = setInterval(() => this.updateDate(), 60000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
      updateDate() {
        const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
        const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
        const date = new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day), 12));
        let days = 0;
        while (days < 3) {
          date.setUTCDate(date.getUTCDate() + 1);
          if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6) days++;
        }
        const formatted = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', { timeZone: 'UTC', weekday: 'long', month: 'short', day: 'numeric' }).format(date);
        this.textContent = this.dataset.template.replace('{date}', formatted);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
